import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 0,
  class: "col-auto"
}

type InputLabelProps = { label: string; required?: boolean };


export default /*@__PURE__*/_defineComponent({
  __name: 'InputLabel',
  props: {
    label: {},
    required: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_Typograph = _resolveComponent("Typograph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Typograph, {
        variant: 'label',
        class: "mb-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.$slots.labelAction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "labelAction")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})